<template>
    <div class="main">
        <div class="leftCol">
            <div class="sysName">{{sysName}}</div>
            <div class="specParam">
                <span class="spItem">专业</span>
                <span class="spDot">·</span>
                <span class="spItem">高效</span>
                <span class="spDot">·</span>
                <span class="spItem">只能</span>
            </div>
            <img src="/static/images/pic/login_bg2.png" class="loginCt">
        </div>
        <div class="rightCol">
            <div class="loginTab">
                <div :class="'ltItem '+(n.key==currTab?'tabSel':'')" v-for="(n,i) in tabs" :key="i" @click="changeTab(n.key)">{{ n.name }}</div>
            </div>
            <div v-show="currTab==1" class="loginForm">
                <el-form ref="form" :model="loginForm" label-width="0px">
                    <el-form-item>
                        <el-input class="logInt" v-model="loginForm.loginAccount" :placeholder="$t('login.account')" size="big" type="text"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-input class="logInt" v-model="loginForm.passwordView" :placeholder="$t('login.password')" size="big" type="password" show-password
                            @keyup.enter.native="accountLogin()"></el-input>
                    </el-form-item>
                    <!-- Auto login checkbox -->
                    <el-form-item>
                        <el-checkbox v-model="autoLogin">自动登录</el-checkbox>
                    </el-form-item>
                </el-form>
                <el-button @click="accountLogin" type="primary" class="loginBtn">{{$t('login.btn')}}</el-button>
            </div>

            <div v-show="currTab==2" class="qrcode-container" v-if="qrCodeUrl">
                <img :src="qrCodeUrl" class="qrcode" alt="微信扫码登录">
                <div class="qrcode-tips">请使用微信扫描二维码登录</div>
            </div>
            <el-button v-show="currTab==2" @click="refreshQRCode" type="primary" class="loginBtn">{{qrCodeBtnText}}</el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "login",
    data() {
        return {
            sysName: config.sysName,
            loginForm: {
                loginAccount: '',
                passwordView: '',
            },
            qrCodeUrl: '',
            qrCodeTicket: '',
            qrCodeBtnText: '获取二维码',
            checkLoginTimer: null,
            autoLogin: true, // Track auto login state

            tabs: [
                { name: '账号登录', key: 1 },
                // { name: '微信扫码登录', key: 2 },
            ],
            currTab: 1,
        };
    },
    methods: {
        // 生成登录二维码
        generateQRCode: function () {
            let _this = this;
            this.qrCodeBtnText = '刷新二维码';

            // 获取二维码ticket
            this.req('/wx/generate_qr_ticket', {}, function (data) {
                if (data.success) {
                    _this.qrCodeTicket = data.obj.ticket;
                    _this.qrCodeUrl = config.fileHost + data.obj.img;

                    // 开始轮询检查扫码状态
                    _this.startCheckLogin();
                } else {
                    _this.$message.error(data.message || '获取二维码失败');
                }
            }, 'get');
        },

        // 开始轮询检查登录状态
        startCheckLogin: function () {
            let _this = this;
            // 清除之前的定时器
            if (this.checkLoginTimer) {
                clearInterval(this.checkLoginTimer);
            }

            // 每2秒检查一次登录状态
            this.checkLoginTimer = setInterval(function () {
                _this.checkLoginStatus();
            }, 2000);
        },

        // 检查登录状态
        checkLoginStatus: function () {
            let _this = this;

            this.req('/wx/check_qr_login_status?ticket=' + this.qrCodeTicket, {}, function (data) {
                if (data.success) {
                    const status = data.obj.status;
                    switch (status) {
                        case 0: // 二维码未扫描
                            console.log('等待扫描...');
                            break;
                        case 1: // 二维码已扫描，等待确认
                            console.log('已扫描，等待确认...');
                            break;
                        case 2: // 用户已确认登录
                            clearInterval(_this.checkLoginTimer);
                            _this.initUserData(data.obj.userInfo);
                            break;
                        case 3: // 用户取消登录
                            clearInterval(_this.checkLoginTimer);
                            _this.$message.info('登录已取消');
                            _this.generateQRCode(); // 重新生成二维码
                            break;
                        case 4: // 二维码过期
                            clearInterval(_this.checkLoginTimer);
                            _this.$message.warning('二维码已过期，请刷新');
                            _this.qrCodeBtnText = '获取二维码';
                            break;
                    }
                } else {
                    console.error('检查登录状态失败', data.message);
                }
            }, 'get', false);
        },

        // 刷新二维码
        refreshQRCode: function () {
            if (this.qrCodeUrl) {
                this.generateQRCode();
            } else {
                this.generateQRCode();
            }
        },

        // 登录成功后的用户数据初始化
        initUserData: function (data) {
            let _this = this;
            sessionStorage.setItem("hwt-token", data.token);
            sessionStorage.setItem("head", data.head);
            sessionStorage.setItem("nickName", data.nickName);
            sessionStorage.setItem("mid", data.mid);
            sessionStorage.setItem("level", data.level);
            sessionStorage.setItem("zone", data.zone);
            sessionStorage.setItem("fontSize", data.fontSize);
            sessionStorage.setItem("orgName", data.orgName);

            this.$router.push("/");
        },

        resize: function () {
            let h = document.body.clientHeight;
            let mt = (h - 550) / 2 - 30;
            if (mt < 0) {
                mt = 0;
            }
            this.mt = mt;
        },
        ckNewVersion: function () {
            this.req('/common/qry_web_version', {}, function (data) {
                if (data.success) {
                    let newVersion = data.obj;
                    let locVersion = localStorage.getItem('qnbVersion');
                    localStorage.setItem('qnbVersion', newVersion);

                    if (newVersion != locVersion) {
                        window.location.reload(true);
                    }
                }
            }, 'get')
        },

        // Check if auto login is enabled and populate fields
        checkAutoLogin() {
            const autoLogin = localStorage.getItem('autoLogin') === 'true';
            const savedAccount = localStorage.getItem('loginAccount');
            const savedPassword = localStorage.getItem('passwordView');

            if (autoLogin && savedAccount && savedPassword) {
                this.autoLogin = true;
                this.loginForm.loginAccount = savedAccount;
                this.loginForm.passwordView = savedPassword;

                // Trigger login automatically if auto-login is enabled
                this.accountLogin();
            }
        },

        buildAutoStatus: function () {
            if (this.autoLogin) {
                // Save login credentials to localStorage
                localStorage.setItem('autoLogin', 'true');
                localStorage.setItem('loginAccount', this.loginForm.loginAccount);
                localStorage.setItem('passwordView', this.loginForm.passwordView);
            } else {
                // Remove saved credentials from localStorage
                localStorage.removeItem('autoLogin');
                localStorage.removeItem('loginAccount');
                localStorage.removeItem('passwordView');
            }
        },

        accountLogin: function () {
            let _this = this;
            this.req('/wx/account_login', this.loginForm, function (data) {
                if (data.success) {
                    _this.buildAutoStatus();
                    _this.initUserData(data.obj);
                } else {
                    _this.$message.error(data.message || '登录失败');
                }
            })
        },
        changeTab: function (tab) {
            this.currTab = tab;
        },
    },
    mounted: function () {
        this.$nextTick(function () {
            console.log("mounted login -- >");
            let _this = this;
            // this.ckNewVersion();

            this.checkAutoLogin();

            this.resize();
            window.addEventListener('resize', () => {
                _this.resize();
            });
        });
    },

    // 组件销毁前清除定时器
    beforeDestroy() {
        if (this.checkLoginTimer) {
            clearInterval(this.checkLoginTimer);
        }
    }
};
</script>

<style scoped>
.main {
    height: 100%;
    /* padding-top: calc(50vh - 180px); */
    display: flex;
}

.loginBtn {
    width: 150px;
    box-sizing: border-box;
    border-radius: 20px;
    display: block;
    margin: 40px auto;
}
.loginForm {
    width: 300px;
    margin: auto;
    margin-top: 40px;
}
.loginForm /deep/ .el-form-item__label {
    color: #fff;
}

.leftCol {
    flex: 3;
    background-color: #077cf5;
    padding-top: calc(50vh - 300px);
}
.rightCol {
    flex: 2;
    box-sizing: border-box;
    padding-top: calc(50vh - 300px);
    background-color: #fff;
}
.loginTit {
    font-size: 28px;
    text-align: center;
    font-weight: bold;
    letter-spacing: 4px;
}
.sysName {
    color: #fff;
    text-align: center;
    font-size: 36px;
    letter-spacing: 3px;
}
.specParam {
    text-align: center;
    color: #ffffffcc;
    margin-top: 20px;
}
.spItem {
}
.spDot {
    padding: 0 10px;
}
.loginCt {
    width: 500px;
    display: block;
    margin: auto;
    margin-top: 30px;
}

/* 扫码登录相关样式 */
.qrcode-container {
    text-align: center;
    margin: 10px 0 30px;
}

.qrcode {
    width: 200px;
    height: 200px;
    margin: 0 auto;
    display: block;
    border: 1px solid #eee;
    padding: 10px;
}

.qrcode-tips {
    margin-top: 15px;
    color: #666;
    font-size: 14px;
}

.loginTab {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;
    line-height: 60px;
    gap: 20px;
}
.ltItem {
    color: #999;
    font-size: 16px;
    cursor: pointer;
}
.tabSel {
    font-weight: bold;
    color: #077cf5;
    font-size: 22px;
}
</style>


// WEBPACK FOOTER //
// src/components/login.vue